import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";

import Tile from "shared/react_components/Tile";
import Centered from "shared/react_components/Centered";

import { paneTitle } from "calls/styles/CallDetails.module.scss";
import ScoreColors from "calls/styles/scoreColors.scss";

import ScoreDetail from "./ScoreDetail";
import NoScoreAvailable from "calls/components/NoScoreAvailable";

const ScoresPane = ({ scoreDetails }) => (
  <div className="pl-3 pt-1">
    <span className={paneTitle}> Call Scores </span>
    {
      isEmpty(scoreDetails) ? (
        <Tile body>
          <Centered height='500'>
            <NoScoreAvailable message="Create and activate scorecards to measure your agents performance on every call"/>
          </Centered>
        </Tile>
      ) : (
        scoreDetails.map(({ scorecardName, totalScore, totalPossibleScore, criteriaDetails }, index) => (
          <ScoreDetail
            key={index}
            color={ScoreColors[`color-${(index % 5) + 1}`]}
            scorecardName={scorecardName}
            totalScore={totalScore}
            totalPossibleScore={totalPossibleScore}
            criteriaDetails={criteriaDetails}
          />
        ))
      )
    }
  </div>
);

ScoresPane.propTypes = {
  scoreDetails: PropTypes.arrayOf(
    PropTypes.shape({
      scorecardName: PropTypes.string,
      totalScore: PropTypes.number,
      totalPossibleScore: PropTypes.number,
      criteriaDetails: PropTypes.arrayOf(
        PropTypes.shape({
          condition: PropTypes.string.isRequired,
          score: PropTypes.number,
          explanation: PropTypes.string
        })
      )
    })
  )
};

export default ScoresPane;
